import React from 'react';
import { Copy, Stack } from '@grubhubprod/gh-cookbook-react';
import { SubdepartmentControl } from 'src/components/enterprise/features/Corporate/components/Form/SubdepartmentControl/SubdepartmentControl';
import { LocationInternalIDControl } from 'src/components/enterprise/features/Corporate/components/Form/LocationInternalIDControl/LocationInternalIDControl';

export function OptionalReportingWrapper(): JSX.Element {
  return (
    <Stack>
      <Stack y="x-sm">
        <Copy variant="body" color="secondaryText">
          Optional Reporting Features
        </Copy>
      </Stack>
      <Stack y="xx-sm">
        <SubdepartmentControl
          name="subDepartmentEnabled"
          id="subDepartmentEnabled"
        />
      </Stack>
      <Stack y="xx-sm">
        <LocationInternalIDControl
          name="locationInternalIdEnabled"
          id="locationInternalIdEnabled"
        />
      </Stack>
    </Stack>
  );
}
